// @tenorlab/nuxt-dashboard-pro
// file: app/dashboard-customs-demo.ts
import type { IDashboardConfig } from '@tenorlab/vue-dashboard'
import { cssSettingsCatalog } from '@tenorlab/vue-dashboard/core'
import { filterDefaultChildWidgets, filterDefaultWidgets } from './dashboard-defaults'
import { getWidgetCatalog } from './widgets-catalog'

// additional custom dashboards only for demo purposes
export const getAdditionalDashboardsForDemo = async (
  user: any,
  clientAppKey: string,
): Promise<IDashboardConfig[]> => {
  const userID = user.userID || 0
  const widgetsCatalog = await getWidgetCatalog(user)
  const availableWidgetKeys = [...widgetsCatalog.keys()]

  return [
    {
      userID,
      clientAppKey,
      dashboardId: 'custom1',
      dashboardName: 'Custom 1',
      zoomScale: 1,
      responsiveGrid: true,
      widgets: filterDefaultWidgets(
        ['WidgetContainer_container1', 'WidgetContainer_container2', 'WidgetContainer_container3'],
        availableWidgetKeys,
      ),
      childWidgetsConfig: filterDefaultChildWidgets(
        [
          {
            parentWidgetKey: 'WidgetContainer_container1',
            widgetKey: 'WidgetSmallCardTransparentSample1',
          },
          {
            parentWidgetKey: 'WidgetContainer_container1',
            widgetKey: 'WidgetSmallCardTransparentSample2',
          },
          {
            parentWidgetKey: 'WidgetContainer_container1',
            widgetKey: 'WidgetSmallCardTransparentSample3',
          },
          {
            parentWidgetKey: 'WidgetContainer_container2',
            widgetKey: 'WidgetOutstandingBalance',
          },
          {
            parentWidgetKey: 'WidgetContainer_container2',
            widgetKey: 'WidgetRecentPayments',
          },
          {
            parentWidgetKey: 'WidgetContainer_container3',
            widgetKey: 'WidgetTotalOrders',
          },
          {
            parentWidgetKey: 'WidgetContainer_container3',
            widgetKey: 'WidgetWithExtraProps',
          },
        ],
        availableWidgetKeys,
      ),
      cssSettings: [...cssSettingsCatalog],
    },

    {
      userID,
      clientAppKey,
      dashboardId: 'custom2',
      dashboardName: 'Custom 2',
      zoomScale: 1,
      responsiveGrid: true,
      widgets: filterDefaultWidgets(
        [
          'WidgetAccumulatedWaterfall',
          'WidgetForexRates',
          'WidgetGauge',
          'WidgetOrderStatus',
          'WidgetLargeSample',
          'WidgetTopProducts',
          'WidgetRecentOrders',
        ],
        availableWidgetKeys,
      ),
      childWidgetsConfig: [],
      cssSettings: [...cssSettingsCatalog],
    },
  ]
}
